// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownItem_root__2ahZE","left":"DropdownItem_left__25lWa","right":"DropdownItem_right__23iBY","premium":"DropdownItem_premium__xizEY"};